const withShopifyWidth = (url, width) => {
  if (!url || String(url).includes("width=")) {
    return url;
  }

  const separator = String(url).includes("?") ? "&" : "?";

  return `${url}${separator}width=${width}`;
};

/**
 * Adds retina srcset variants for mega-nav banners when they are not set in JSON.
 * Uses Shopify CDN width params so 1x/2x assets match the rendered banner size.
 */
export function enhanceNavigationBannerImages(images = {}) {
  const base = images.largeMedia || images.mediumMedia || images.smallMedia;

  if (!base) {
    return images;
  }

  const largeSrc = images.largeMedia || base;
  const mediumSrc = images.mediumMedia || largeSrc;
  const smallSrc = images.smallMedia || mediumSrc;

  return {
    ...images,
    smallMedia: smallSrc,
    mediumMedia: mediumSrc,
    largeMedia: largeSrc,
    smallMedia2x: images.smallMedia2x || withShopifyWidth(smallSrc, 800),
    mediumMedia2x: images.mediumMedia2x || withShopifyWidth(mediumSrc, 1100),
    largeMedia2x: images.largeMedia2x || withShopifyWidth(largeSrc, 1400),
  };
}
